export default __webpack_public_path__ + "static/media/Muli-Bold.85c0b343.ttf";